import * as ActiveStorage from "activestorage"
ActiveStorage.start()

import "controllers"
import "styles"
import "@mux/mux-player"

# Global Clipboard behavior
Clipboard = require "clipboard"
document.addEventListener "DOMContentLoaded", ->
  clipboard = new Clipboard('.clipboardjs')
  clipboard.on 'success', (event) ->
    copyElement = event.trigger

    $(copyElement)
      .tooltip({ html: 'true', title: '<i class="fa fa-check-circle text-success"></i> Copied!', trigger: 'manual' })
      .tooltip('show')

    setTimeout(=>
      $(copyElement).tooltip('destroy')
    , 1500)